import JsPDF from "jspdf";
import "jspdf-autotable";

export const savePDF = (data, columns, fileName) => {
  const formattedColumns = columns?.map((col) => col.header);
  const columnKeys = columns?.map((col) => col.key);
  const formattedData = data?.map((d, index) =>
    columnKeys?.map((i) => (i === "serealNo" ? index + 1 : d[i])),
  );
  const doc = new JsPDF("landscape");
  doc.autoTable({
    head: [formattedColumns],
    body: formattedData,
    styles: {
      fontSize: 8,
    },
    headStyles: {
      fillColor: "#5d44ff",
      textColor: [255, 255, 255],
    },
    theme: "grid",
    pageBreak: "auto",
  });
  doc.save(`${fileName}.pdf`);
};
